import { createAction, createReducer } from 'utils/reducer';

const PATH = 'featureFlags/';

export const FEATURE_FLAGS = {
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  EDIT_PERMISSION: `${PATH}EDIT_PERMISSION`,
  EDIT_PERMISSION_SUCCESS: `${PATH}EDIT_PERMISSION_SUCCESS`,
};

export const featureFlagsActions = {
  getStateFromApi: createAction(FEATURE_FLAGS.GET_STATE_FROM_API),
  getStateFromApiSuccess: createAction(FEATURE_FLAGS.GET_STATE_FROM_API_SUCCESS, 'payload'),
  editPermission: createAction(FEATURE_FLAGS.EDIT_PERMISSION, 'permission_id', 'is_active'),
  editPermissionSuccess: createAction(FEATURE_FLAGS.EDIT_PERMISSION_SUCCESS, 'permission'),
};

const initialState = {
  permissions: {},
};

const featureFlags = createReducer(initialState, {
  [FEATURE_FLAGS.GET_STATE_FROM_API_SUCCESS](state, action) {
    state.permissions = action.payload.permissions || action.payload || {};
  },
  [FEATURE_FLAGS.EDIT_PERMISSION_SUCCESS](state, action) {
    const { permission } = action;
    const permissions = state.permissions?.permissions || state.permissions;
    if (permissions && permissions[permission.id]) {
        permissions[permission.id] = {
            ...permissions[permission.id],
            ...permission
        };
    }
  },
});

export default featureFlags;
